<template>
  <div v-if="!inline" class="maplibregl-ctrl maplibregl-ctrl-group MapExport">
    <MapControlTooltip :text="$t('geoportal.mapControls.exportMap')">
      <button
        :aria-label="$t('geoportal.mapControls.exportMap')"
        @click.stop="mapStore.isMapExportActive = !mapStore.isMapExportActive"
        class="MapExport__btn pointer p-2 inline-flex items-center transition-all duration-200 text-white"
        :class="{
          isActive: mapStore.isMapExportActive,
        }"
      >
        <Icon icon="$printer" color="var(--color-main)" />
      </button>
    </MapControlTooltip>
  </div>
  <MapControlTooltip v-else :text="$t('geoportal.mapControls.exportMap')">
    <button
      :aria-label="$t('geoportal.mapControls.exportMap')"
      @click.stop="mapStore.isMapExportActive = !mapStore.isMapExportActive"
      class="MapExport__btn pointer p-2 inline-flex items-center transition-all duration-200 text-white"
      :class="{
        isActive: mapStore.isMapExportActive,
      }"
    >
      <Icon icon="$printer" color="var(--color-main)" />
    </button>
  </MapControlTooltip>
</template>
<script setup lang="ts">
import Icon from '@/components/ui/Icon.vue'
import MapControlTooltip from '@/components/map/controls/MapControlTooltip.vue'
import { useMyMapStore } from '@/stores/myMapStore'

defineProps<{
  inline?: boolean
}>()

const mapStore = useMyMapStore()
</script>

<style>
.MapExport {
  flex-flow: row nowrap !important;
  margin-right: 0.3rem !important;
}

.MapExport__btn {
  justify-content: center;
  transition: background-color 0.2s;
}
</style>
